import { z } from 'zod';

export const EmbedTriggerIconType = z.enum(['CHAT', 'HELP', 'LOGO', 'NONE']);
export type EmbedTriggerIconType = z.infer<typeof EmbedTriggerIconType>;

export const EMBED_TRIGGER_ICON_OPTIONS = [
  { id: 0, name: 'Chat bubble', value: 'CHAT' as const },
  { id: 1, name: 'Question mark', value: 'HELP' as const },
  { id: 2, name: 'Formsuite logo', value: 'LOGO' as const },
  { id: 3, name: 'None', value: 'NONE' as const },
];

export function embedTriggerIconTypeToDataAttr(type?: EmbedTriggerIconType | null): string {
  switch (type) {
    case 'HELP':
      return 'help';
    case 'LOGO':
      return 'logo';
    case 'NONE':
      return 'none';
    default:
      return 'chat';
  }
}

export function embedTriggerIconTypeFromDataAttr(value?: string | null): EmbedTriggerIconType {
  switch (value) {
    case 'help':
      return 'HELP';
    case 'logo':
      return 'LOGO';
    case 'none':
      return 'NONE';
    default:
      return 'CHAT';
  }
}
